'use strict';

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var hashlru = require('hashlru');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var hashlru__default = /*#__PURE__*/_interopDefaultLegacy(hashlru);

var TLRU = /*#__PURE__*/function () {
  function TLRU(maxSize) {
    _classCallCheck(this, TLRU);

    this.lru = hashlru__default["default"](maxSize);
  }

  _createClass(TLRU, [{
    key: "get",
    value: function get(key) {
      var value = this.lru.get(key);

      if (value) {
        if (value.expire && value.expire < Date.now()) {
          this.lru.remove(key);
          return undefined;
        }

        return value.value;
      }

      return undefined;
    }
  }, {
    key: "set",
    value: function set(key, value, ttl) {
      this.lru.set(key, {
        value: value,
        expire: Date.now() + ttl
      });
    }
  }, {
    key: "has",
    value: function has(key) {
      var value = this.get(key);

      if (value) {
        return true;
      }

      return false;
    }
  }, {
    key: "remove",
    value: function remove(key) {
      this.lru.remove(key);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.lru.clear();
    }
  }]);

  return TLRU;
}();

exports.TLRU = TLRU;